import React, { useState, useEffect } from 'react';
import '../css/main/Home.css';
import EncryptionUtils from '../main/encryptionUtils';
import AuditorDashboard from './AuditorDashboard';
import QCDashboard from './QCDashboard';
import PMDashboard from './PMDashboard';
import DMDashboard from './DMDashboard';
import DHDashboard from './DHDashboard';
import AdminDashboard from './AdminDashboard';
import TLDashboard from './TLDashboard';
import TMDashboard from './TMDashboard';
import QMDashboard from './QMDashboard';
import FHDashboard from './FHDashboard';
import FSDashboard from './FSDashboard';
import PSDashboard from './PSDashboard';
import SSDashboard from './SSDashboard';
import SADashboard from './SADashboard';
const Home: React.FC = () => {
  const [, setIsLoading] = useState(true);
  const [currentRole, setCurrentRole] = useState('');
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    try {
      const timer = setTimeout(() => {
        const role = EncryptionUtils.get('roleName')?.toLowerCase() || 'admin';
        if (!role) {
          throw new Error('Role not found in local storage');
        }
        setCurrentRole(role);
        setIsLoading(false);
      }, 500);
      return () => clearTimeout(timer);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      setIsLoading(false);
    }
  }, []);
  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }
  return (
    <div className="dashboard-container">
      {currentRole === 'admin' && <AdminDashboard />}
      {currentRole === 'auditor' && <AuditorDashboard />}
      {currentRole === 'quality consultant' && <QCDashboard />}
      {currentRole === 'project manager' && <PMDashboard />}
      {currentRole === 'delivery manager' && <DMDashboard />}
      {currentRole === 'delivery head' && <DHDashboard />}
      {currentRole === 'quality manager' && <QMDashboard />}
      {currentRole === 'test manager' && <TMDashboard />}
      {currentRole === 'technical lead' && <TLDashboard />}
      {currentRole === 'function head' && <FHDashboard />}
      {currentRole === 'function spoc' && <FSDashboard />}
      {currentRole === 'primary spoc' && <PSDashboard />}
      {currentRole === 'secondary spoc' && <SSDashboard />}
      {currentRole === 'super admin' && <SADashboard />}
    </div>
  );
};
export default Home;